export default __webpack_public_path__ + "static/media/arrowDown-dark.91fa372e.svg";